// Ring App Store: Tenant picker (pre-session) client.
//
// Hits the BFF tenant-picker endpoints which run BEFORE the X-Acting-Role
// header is established, so every call sets `skipActingRole`.

import { api } from "./client";
import type { TenantCandidate } from "@/types/tenant";

export interface ActivateTenantResponse {
  /**
   * Server may respond with 302 redirect (handled by browser when navigating)
   * or a JSON envelope when called via fetch. We model the JSON envelope.
   */
  redirect_to?: string;
}

export const tenantPickerClient = {
  /** GET /api/tenant-picker/candidates — pre-session-cookie scoped. */
  async listCandidates(signal?: AbortSignal): Promise<TenantCandidate[]> {
    const res = await api.get<{ candidates: TenantCandidate[] }>(
      "/api/tenant-picker/candidates",
      { signal, skipActingRole: true },
    );
    return res.candidates ?? [];
  },

  /** POST /api/tenant-picker/activate — exchanges pre-session for full session. */
  activate(tenantId: string, signal?: AbortSignal): Promise<ActivateTenantResponse> {
    return api.post<ActivateTenantResponse>(
      "/api/tenant-picker/activate",
      { tenant_id: tenantId },
      { signal, skipActingRole: true },
    );
  },
};
